export default __webpack_public_path__ + "static/media/search_table.fe526377.svg";